import { useSelector } from "react-redux";
import { secondsToHHMMSS, sumOfRecordCounts, sumOfRecordCountsWithoutDecimal } from "../../helper/utility";
import { Constants } from "../Common/Constants";
import AreaGraphMonthly from "../Common/Graphs/AreaGraphMonthyl";

const Monthly = () => {
  // const { userSingle } = useSelector((store) => store.Users);
  const totalWeightsLifted = useSelector((store) => store.userReportReducer.totalWorkoutReport.totalWeightLifted);
  const totalReps = useSelector((store) => store.userReportReducer.totalWorkoutReport.reps);
  const caloriesBurnt = useSelector((store) => store.userReportReducer.totalWorkoutReport.caloriesBurnt);
  const timeUnderTension = useSelector((store) => store.userReportReducer.totalWorkoutReport.timeUnderTension);
  const totalWorkouts = useSelector((store) => store.userReportReducer.totalWorkoutReport.workouts);
  const quickTrainWorkouts = useSelector((store) => store.userReportReducer.userQuickTrainWorkouts);


  const sumOfTotalWeightsLifted = sumOfRecordCounts(totalWeightsLifted);
  const sumOfTotalReps = sumOfRecordCountsWithoutDecimal(totalReps);
  const sumOfTotalCalories = sumOfRecordCounts(caloriesBurnt);
  const sumOfTimeUnderTension = sumOfRecordCounts(timeUnderTension);
  const sumOfTotalWorkouts = sumOfRecordCountsWithoutDecimal(totalWorkouts);
  const sumOfQuickTrainWorkouts = sumOfRecordCountsWithoutDecimal(quickTrainWorkouts);


  return (
    <div className="row mt-4">
      {/* <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          data={userSingle?.totalWeightListedByCategory}
          title={Constants.totalWeightLiftedSplit}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          data={userSingle?.totalRepsByCategory}
          title={Constants.totalRepsSplit}
          format=""
        />
      </div> */}
      {/* <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          data={userSingle?.strengthAssessment}
          title={Constants.strengthAssessment}
          format=""
        />
      </div> */}
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={userSingle?.totalWeight}
          data={totalWeightsLifted}
          title={`${Constants.totalWeightLifted} ${sumOfTotalWeightsLifted}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={userSingle?.totalReps}
          data={totalReps}
          title={`${Constants.totalReps} ${sumOfTotalReps}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={userSingle?.caloriesBurnt}
          data={caloriesBurnt}
          title={`${Constants.caloriesBurnt} ${sumOfTotalCalories}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={userSingle?.totalTimeUnderTension}
          data={timeUnderTension}
          title={`${Constants.timeUnderTension} ${secondsToHHMMSS(sumOfTimeUnderTension)}`}
          format=""
          yAxisType={"time"}
        />
      </div>
      {/* <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          data={userSingle?.progress}
          title={Constants.progress}
          format=""
        />
      </div> */}
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={userSingle?.totalQuickTrainWorkout}
          data={quickTrainWorkouts}
          title={`${Constants.quickTrainWorkout} ${sumOfQuickTrainWorkouts}`}
          format=""
        />
      </div>
      <div id="chart" className="col-md-4">
        <AreaGraphMonthly
          // data={userSingle?.totalWorkoutCreated}
          data={totalWorkouts}
          title={`${Constants.totalWorkouts} ${sumOfTotalWorkouts}`}
          format=""
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Monthly;
